import React from 'react'
import moment from 'moment/moment'
import {Link} from 'react-router-dom'
import {setUser} from '@sentry/react'

function PackingItemRow(props) {
    const {item, setType, setBrand, setUser} = props
    const {
        barcode,
        type,
        size,
        packing_info,
        batch_id,
        batch,
        brand,
        brand_name,
        order3d,
        order3d_at,
        pos: itemIndex,
    } = item
    const {
        barcodeNumber,
    } = {...barcode}
    const barcodeStr = barcodeNumber + '_' + itemIndex
    const is3D = order3d && order3d_at && barcodeStr && itemIndex
    const onClickType = (value) => {
        setType(value)
    }
    const onClickBrand = (value) => {
        setBrand(value)
    }
    const onSetUser = (user) => () => {
        setUser(user)
    }

    const brandName = brand ? brand.name : brand_name
    const vBatch = batch || batch_id

    return (
        <tr>
            <td>
                {is3D &&
                <Link
                    to={`/order-item?template=${barcodeStr}`}
                    target="_blank">
                    #{barcodeStr}
                </Link>
                }
                {
                    !is3D && `#${barcodeStr}`
                }
            </td>
            <td className="ProductType">
                {!!type &&
                <span className="mr-2" onClick={() => onClickType([type])}>{type}</span>
                }
                {!!brandName &&
                <div className="Brand">
                    <span className="mr-2" onClick={() => onClickBrand([brandName])}>{brandName}</span>
                </div>
                }
            </td>

            <td>{size || '-'}</td>
            <td>
                {
                    (vBatch &&
                        <Link to={`/batches/${vBatch._id || vBatch.id}`}>
                            {vBatch.name}
                        </Link>
                    ) || '-'
                }
            </td>
            <td>{moment(packing_info.date).format('HH:mm DD/MM/YYYY') || '-'}</td>
            <td>
                {
                    packing_info.user &&
                    <span className="mr-2" onClick={onSetUser(packing_info.user)}>{packing_info.user}</span>
                }
                {
                    !packing_info.user && '-'
                }
            </td>
        </tr>
    )
}

export default PackingItemRow